/*
 *
 * PblManagementActionsModal
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 10-Jul-2025
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  confirm: <PortalMessage id='t.app.project.btn.confirm' defaultMessage='Confirm' />,
  titleModalManage: (id) => (
    <PortalMessage
      id='t.app.pblManagement.actions.titleModalManage'
      defaultMessage='Pay-by-link {id} - Manage'
      values={{ id }}
    />
  ),
  titleModalDelete: (id) => (
    <PortalMessage
      id='t.app.pblManagement.actions.titleModalDelete'
      defaultMessage='Pay-by-link {id} - Delete'
      values={{ id }}
    />
  ),
  subTitleModalManage: (
    <PortalMessage
      id='t.app.pblManagement.actions.subTitleManage'
      defaultMessage='Proceeding, the pay-by-link will be updated.'
    />
  ),
  subTitleModalDelete: (
    <PortalMessage
      id='t.app.pblManagement.actions.subTitleDelete'
      defaultMessage='Proceeding, the pay-by-link will be deleted.'
    />
  ),
  uses: <PortalMessage id='t.app.pblManagement.actions.uses' defaultMessage='Uses made:' />,
  activated: <PortalMessage id='t.app.subscriptionPlans.search.paymentPlan.status.active' defaultMessage='Active' />,
  deactivated: (
    <PortalMessage id='t.app.subscriptionPlans.search.paymentPlan.status.inactive' defaultMessage='Inactive' />
  ),
  mandatoryField: (
    <PortalMessage id='t.app.terminalsManagement.disputeless.form.requiredField' defaultMessage='* Mandatory field' />
  ),
  maxPayments: <PortalMessage id='t.app.pblManagement.actions.maxUses' defaultMessage='Max number of uses' />
}

export const messages = {
  warningAriaLabel: {
    id: 't.app.paybylink.wizard.advancedSettings.contractAndSubscription.popup.title',
    defaultMessage: 'Warning!'
  }
}

export const captions = defineMessages({
  validEmail: { id: 't.app.settings.createUser.validEmail', defaultMessage: 'Invalid email address' },
  validName: { id: 't.app.settings.createUser.validName', defaultMessage: 'Invalid characters:' },
  validRole: { id: 't.app.settings.createUser.validRole', defaultMessage: 'User role is a required field' },
  status: { id: 't.app.accessibility.settings.users.status.ariaLabel', defaultMessage: 'Status' },
  calendar: {
    id: 't.app.accessibility.icons.input.calendar.ariaLabel',
    defaultMessage: 'Calendar icon'
  },
  expiringDate: {
    id: 't.app.paybylink.request.expirationDate',
    defaultMessage: 'Expiration date'
  },
  expiringTime: {
    id: 't.app.pblManagement.actions.expiringTime',
    defaultMessage: 'Expiration time'
  },
  ariaTitleManage: {
    id: 't.app.settings.popup.users.manage.ariaTitle',
    defaultMessage: 'Manage User'
  },
  ariaTitleCreate: {
    id: 't.app.settings.popup.users.manage.ariaTitleCreate',
    defaultMessage: 'Create new User title: Create new User'
  },
  activated: {
    id: 't.app.settings.users.activated',
    defaultMessage: 'ENABLE'
  },
  deactivated: {
    id: 't.app.settings.users.deactivated',
    defaultMessage: 'DISABLE'
  },
  role: {
    id: 't.app.settings.users.role',
    defaultMessage: 'role'
  },
  close: {
    id: 't.app.project.btn.close',
    defaultMessage: 'Close'
  },
  admin: {
    id: 't.app.settings.users.role.admin',
    defaultMessage: 'Admin'
  },
  operator: {
    id: 't.app.settings.users.role.operator',
    defaultMessage: 'Operator'
  },
  reporter: {
    id: 't.app.settings.users.role.viewer',
    defaultMessage: 'Viewer'
  },
  mandatoryField: {
    id: 't.app.settings.processingRules.form.isRequiredError',
    defaultMessage: 'Field is Required'
  },
  maxPayments: { 
    id: 't.app.pblManagement.actions.maxUses', 
    defaultMessage: 'Max number of uses' 
  }
})

export default formattedMessage
